import { i18n } from '@/commons/utils';
import { init as initAddressBookForm } from './account-address-book-form';


const URL = {
  SET_FAVORITE_ADDRESS: 'account/selectPreferedShippingAddress',
  DELETE_ACTOR: '/atg/userprofiling/ProfileActor/deleteShippingAddress'
};

let addressbook;

let modal;
let modalCancelButton;
let modalConfirmationButton;

let addressId = null;

export const init = () => {
  initAddressBookForm();

  addressbook = cube.$id('js-address-book');
  modal = cube.$id('js-address-book-modal');

  const addAddressButtons = cube.$$('.js-add-address-button');
  addAddressButtons.on('click', addAddress);

  const editAddressLinks = cube.$$('.js-edit-address-link');
  editAddressLinks.on('click', editAddress);

  const deleteAddressButtons = cube.$$('.js-remove-address');
  deleteAddressButtons.on('click', deleteAddressModal);

  const addressRadioButtons = cube.$$('.js-favorite-address-radio-button');
  addressRadioButtons.on('change', event => setFavoriteAddress(event, addressRadioButtons));

  modalConfirmationButton = cube.$id('js-address-book-modal-confirmation');
  if (modalConfirmationButton)
    modalConfirmationButton.on('click', () => deleteAddress(addressId));

  modalCancelButton = cube.$id('js-address-book-modal-cancel');
  if (modalCancelButton)
    modalCancelButton.on('click', closeAddressModal);
};


/**
 * Display the add address form and hide the address list.
 *
 * @param {Event} event
 */
const addAddress = event => {
  event.preventDefault();

  const addressBookList = cube.$id('js-address-book-list');
  const addressBookForm = cube.$id('js-address-book-form');

  if (addressBookForm.classList.contains('hidden')) {
    addressBookList.classList.add('hidden');
    addressBookForm.classList.remove('hidden');
  }
  else {
    addressBookForm.classList.add('hidden');
    addressBookList.classList.remove('hidden');
  }
};


/**
 * Reload the adress book cartridge to get the selected address informations and display the update form.
 *
 * @param {*} event
 */
const editAddress = event  => {
  event.preventDefault();

  addressId = event.target.closest('.address').dataset.addressId;

  cube.cartridge('js-address-book')
    .after(() => {
      initAddressBookForm();
    })
    .reload({
      addressId
    });
};


/**
 * Display a confirmation modal when a customer wants to delete an address.
 *
 * @param {Event} event
 */
const deleteAddressModal = event => {
  event.preventDefault();

  addressId = event.target.closest('.address').dataset.addressId;
  modal.checked = true;
};


/**
 * Close the confirmation modal.
 *
 */
const closeAddressModal = () => {
  modal.checked = false;
};


/**
 * Reload the address book to delete the selected address.
 *
 * @param {String} id The address id.
 */
const deleteAddress = id => {
  const { dataset } = addressbook;
  const content = dataset.tUrl;

  dataset.tUrlActor = '';
  dataset.tUrl = URL.DELETE_ACTOR;


  cube.cartridge('js-address-book')
    .after(() => {
      modal.checked = false;

      cube.alert.success(i18n('profile.changesSaved'));
      init();
    })
    .reload({
      addressIdToDelete: id,
      contentCollection: content
    });
};


/**
 * Send an xhr to change the customer's favorite address.
 *
 * @param {Event} event
 * @param {HTMLInputElement} radios The radios used to set the favorite address.
 */
const setFavoriteAddress = (event, radios) => {
  addressId = event.target.closest('.address').dataset.addressId;

  radios.forEach(radio => {
    radio.disabled = true;
  });

  cube.ajax
    .post(
      URL.SET_FAVORITE_ADDRESS,
      {
        idAddress: addressId
      }
    )
    .onSuccess(response => setFavoriteAddressSuccess(response, radios))
    .onError(response => setFavoriteAddressError(response, radios))
    .call();
};


/**
 * Update the customer's favorite address and reload the address book cartridge if the XHR returns no error(s).
 *
 * @param {Object} response The XHR response.
 * @param {HTMLInputElement} radios The radios used to set the favorite address.
 */
const setFavoriteAddressSuccess = (response, radios) => {
  if (setFavoriteAddressError(response, radios))
    return;

  cube.cartridge('js-address-book')
    .after(() => {
      cube.alert.success(i18n('profile.changesSaved'));
      init();
    })
    .reload();
};


/**
 * Display an error if the XHR returns error(s).
 *
 * @param {Object} response The XHR response.
 * @param {*} radios The radios used to set the favorite address.
 */
const setFavoriteAddressError = (response, radios) => {
  if (
    typeof response === 'string' ||
    typeof response === 'object' && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message
  )
  {
    if (typeof response === 'string')
      cube.alert.error(i18n('error.oc.call'));
    else
      cube.alert.error(response.responseTO.errors[0].message);

    radios.forEach(radio => {
      radio.disabled = false;
    });

    return true;
  }

  return false;
};


// WEBPACK FOOTER //
// ./src/customer/account/account-address-book.js